import React from 'react';
import { StyleSheet, ImageBackground, ImageBackgroundProps, StyleProp, View, ViewStyle } from 'react-native';
import { CardElement, Text, Icon, Button } from '@ui-kitten/components';
import { Card } from '../_primatives';
import { PoallCardListItem } from '../_primatives/PoallCard';


export interface CardItem {
    title: string,
    imageUrl?: string,
    id: string;
    description: string;
}


interface OverlayImageStyle extends ViewStyle {
    overlayColor?: string;
}

export interface ImageOverlayProps extends ImageBackgroundProps {
    style?: StyleProp<OverlayImageStyle>;
    children?: React.ReactNode;
}

const DEFAULT_OVERLAY_COLOR = 'rgba(0, 0, 0, 0.45)';
export const ImageOverlay = (props?: ImageOverlayProps): React.ReactElement<ImageBackgroundProps> => {

    const { style, children, ...imageBackgroundProps } = props;
    const { overlayColor, ...imageBackgroundStyle } = StyleSheet.flatten(style);

    return (
        <ImageBackground {...imageBackgroundProps} style={imageBackgroundStyle}>
            <View style={[StyleSheet.absoluteFill, { backgroundColor: overlayColor || DEFAULT_OVERLAY_COLOR }]} />
            {children}
        </ImageBackground>
    );
};






export interface CampaignCardProps {
    item: CardItem;
    onPress: (item: CardItem) => void;
    button?: any;
    style?: ViewStyle | ViewStyle[];
}
export interface SurveyCardProps extends CampaignCardProps {
    item: CardItem;
    onPress: (item: CardItem) => void;
    style?: ViewStyle | ViewStyle[];
}
export interface OrganizationCardProps extends CampaignCardProps {
    item: CardItem;
    onPress: (item: CardItem) => void;
    style?: ViewStyle | ViewStyle[];
}
export interface PollCardProps extends CampaignCardProps {
    item: CardItem;
    onPress: (item: CardItem) => void;
    style?: ViewStyle | ViewStyle[];
}


export const CampaignCard = (props: CampaignCardProps): CardElement => {
    const { style, item } = props;
    const onPress = () => props.onPress(item);

    return (
        <Card style={[{ borderRadius: 0 }, style]} onPress={onPress}>
            <ItemTypeHeader title='CAMPAIGN' icon='award-outline'  />
            <Text category='h4'>{item.title}</Text>
            <Text category='p1'>{item.description}</Text>
            {props.button ? props.button : undefined}
        </Card>
    )
};

export const SurveyCard = (props: SurveyCardProps): CardElement => {
    const { style, item } = props;
    const onPress = () => props.onPress(item);

    return (
        <Card style={[style]} onPress={onPress}>
            <SurveyTypeHeader />
            <Text category='h6'>{item.title}</Text>
            <Text category='p1'>{item.description}</Text>
        </Card>
    )
};

export const OrganizationCard = (props: OrganizationCardProps): CardElement => {
    const { style, item } = props;
    const onPress = () => props.onPress(item);

    return (
        <Card style={[style]} onPress={onPress}>
            <ItemTypeHeader title='GROUP' icon='layers-outline' />
            <Text category='h6'>{item.title}</Text>
            <Text category='p1'>{item.description}</Text>
        </Card>
    )
};


export const PollCard = (props: OrganizationCardProps): CardElement => {
    const { style, item } = props;
    const onPress = () => props.onPress(item);

    return (
        <Card style={[style]} onPress={onPress}>
            <PollTypeHeader />
            <Text category='h6'>{item.title}</Text>
            <Text category='p1'>{item.description}</Text>
        </Card>
    )
};



export const ItemTypeHeader = (props: { icon: string, iconStyle?: any, title: string }): React.ReactElement => {
    const { icon, iconStyle, title } = props;
    return (
        <View style={{ flexDirection: 'row' }}>
            <Icon name={icon} style={[{ paddingLeft: 0, marginLeft: -4, paddingRight: 5 }, iconStyle]} height={25} width={25} fill='rgb(143, 155, 179)'/>
            <Text category='s2' appearance='hint'>{title}</Text>
        </View>
    );
};


export const PollTypeHeader = () => <ItemTypeHeader title='POLL' icon='bar-chart-outline' />;
export const SurveyTypeHeader = () => <ItemTypeHeader title=' SURVEY' icon='clipboard-outline'  />;


// const seconds = (new Date().getMilliseconds());
    // const imgDimensions = Math.min(Math.max(seconds < 10 ? seconds + 10 : seconds, 10), 99)
    // const imageUrl: string = 'https://picsum.photos/20' +  imgDimensions;
